import { Component, OnInit } from '@angular/core';
import { MatDialog, Sort } from '@angular/material';
import { Router } from '@angular/router';
import { DBService } from '../../services/db.service';

import { Document, DocumentCategory, DocumentStatus } from '../../model/document';
import { Company } from '../../model/company';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';
import { User } from '../../model/user';
import { AuthenticationService } from '../../services/authentication.service';
import { InputDataComponent } from '../partials/input-data/input-data.component';

declare var Materialize: any;

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
  providers: [DBService]
})
export class DocumentsComponent implements OnInit {

  loading: boolean;

  list: Document[];
  listActive: Document[];
  listInactive: Document[];
  displayList: Document[];

  searchText: string;

  user: User;

  isAdminUser: boolean;
  userCompanyUID: string;

  companies: Company[];
  companiesActive: Company[];
  companiesInactive: Company[];
  companiesUndefined: Company[];
  companyFilter: string;

  statusFilter: string;

  filter: string;
  private sub: any;

  constructor(public dialog: MatDialog, private router: Router, private dbService: DBService, private authService: AuthenticationService, private route: ActivatedRoute) {
    this.displayList = [];
    this.loading = true;
    this.searchText = '';

    this.isAdminUser = this.authService.isAdmin();
    if (!this.isAdminUser) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadData();
    this.loadUser();
  }

  private loadUser() {
    this.user = this.authService.getUser();
  }

  ngOnInit() {
  }

  private loadData() {
    this.dbService.listWithUIDs<Document>('/documents')
      .then(list => {
        this.list = list;

        if (!this.isAdminUser) {
          this.list = this.list.filter(item => item.companyUID === this.userCompanyUID);
        }
    
        this.sub = this.route.params.subscribe(params => {
          this.filter = params['filter'];
        });

        this.loadCompanies();
      })
      .catch(error => console.log(error));
  }

  private loadCompanies() {
    if(this.isAdminUser){
      this.dbService.listWithUIDs<Company>('companies')
        .then(companiesActive => {
          this.companiesActive = companiesActive.filter(c => c.isInactive === false);
          this.list.forEach(item => {
            item['companyName'] = '';
            const diff = Math.abs(new Date().getTime() - item.expirationDate);
            const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            item['isExpired'] = item.expirationDate <= new Date().getTime();
            item['isExpiring'] = diffDays <= 7 && !item['isExpired'];
            const filteredcompaniesActive = companiesActive.filter(c => c.uid === item.companyUID);
            if (filteredcompaniesActive.length > 0) {
              item['companyName'] = filteredcompaniesActive[0].name;
            } else {
              this.dbService.remove('companiesActive', item.uid);
            }
          });  
          this.list = this.list.filter(item => item['companyName'] != '');
          this.loadUsers();
      });

      this.dbService.listWithUIDs<Company>('companies')
        .then(companiesInactive => {
          this.companiesInactive = companiesInactive.filter(c => c.isInactive === true);  
          this.list.forEach(item => {
            item['companyName'] = '';  
            const diff = Math.abs(new Date().getTime() - item.expirationDate);
            const diffDays = Math.ceil(diff / (1000 * 3600 * 24));  
            item['isExpired'] = item.expirationDate <= new Date().getTime();
            item['isExpiring'] = diffDays <= 7 && !item['isExpired'];  
            const filteredcompaniesInactive = companiesInactive.filter(c => c.uid === item.companyUID);
            if (filteredcompaniesInactive.length > 0) {
              item['companyName'] = filteredcompaniesInactive[0].name;
            } else {
              this.dbService.remove('companiesInactive', item.uid);
            }  
          });    
          this.list = this.list.filter(item => item['companyName'] != '');
          this.loadUsers();
      });

      this.dbService.listWithUIDs<Company>('companies')
        .then(companiesUndefined => {
          this.companiesUndefined = companiesUndefined.filter(c => !c.isInactive && c.isInactive !== false);  
          this.list.forEach(item => {
            item['companyName'] = '';  
            const diff = Math.abs(new Date().getTime() - item.expirationDate);
            const diffDays = Math.ceil(diff / (1000 * 3600 * 24));  
            item['isExpired'] = item.expirationDate <= new Date().getTime();
            item['isExpiring'] = diffDays <= 7 && !item['isExpired'];  
            const filteredcompaniesUndefined = companiesUndefined.filter(c => c.uid === item.companyUID);
            if (filteredcompaniesUndefined.length > 0) {
              item['companyName'] = filteredcompaniesUndefined[0].name;
            } else {
              this.dbService.remove('companiesUndefined', item.uid);
            }  
          });      
          this.list = this.list.filter(item => item['companyName'] != '');
          this.loadUsers();
      });

    }
    else
      this.dbService.listWithUIDs<Company>('companies')
        .then(companies => {
          if (this.userCompanyUID) {
            this.companies = companies.filter(c => c.uid === this.userCompanyUID);
            this.companyFilter = this.userCompanyUID;
          } else {
            this.companies = companies;
          }
  
          this.list.forEach(item => {
            item['companyName'] = '';
  
            const diff = Math.abs(new Date().getTime() - item.expirationDate);
            const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
  
            item['isExpired'] = item.expirationDate <= new Date().getTime();
            item['isExpiring'] = diffDays <= 7 && !item['isExpired'];
  
            const filteredCompanies = companies.filter(c => c.uid === item.companyUID);
            if (filteredCompanies.length > 0) {
              item['companyName'] = filteredCompanies[0].name;
            } else {
              this.dbService.remove('companies', item.uid);
            }
  
          });
  
          this.list = this.list.filter(item => item['companyName'] != '');  
          this.loadUsers();

        });
  } 

  private loadUsers() {
    this.dbService.listWithUIDs<Company>('employees')
      .then(employees => {
        this.list.forEach(item => {
          if(employees.filter(u => u.uid === item.sentUserUID)[0]) {
            item['sentUserName'] = employees.filter(u => u.uid === item.sentUserUID)[0].name;
          } else {
            item['sentUserName'] = "Usuário não identificado";
          }
          if (item.status === DocumentStatus.APPROVED || item.status === DocumentStatus.OK) {
            if(employees.filter(u => u.uid === item.approvingUserUID).length > 0) 
              item['approvingUserName'] = employees.filter(u => u.uid === item.approvingUserUID)[0].name;
            else
              item['approvingUserName'] = "Usuário não identificado.";
          }
        });

        this.updateStatus();
        if (this.companyFilter) {
          this.onSearchChange();
        }         
        if(this.filter == "vencidos") {
          this.statusFilter = '0';
          this.onSearchChange();
        }
        this.loading = false;
      });
  }

  private updateStatus() {
    this.list.forEach(item => {
      if (item.status === DocumentStatus.APPROVED) {
        item['statusText'] = 'Aprovado';
      } else if (item.status === DocumentStatus.EXPIRED) {
        item['statusText'] = 'Vencido';
      } else if (item.status === DocumentStatus.WAITING_APPROVAL) {
        item['statusText'] = 'Aguardando Aprovação';
      } else if (item.status === DocumentStatus.DISAPPROVED) {
        item['statusText'] = 'Desaprovado';
      } else {
        item['statusText'] = 'OK';
      }
    });
  }

  onSearchChange() {
    let tempFilter = this.list;

    if (this.companyFilter) {
      tempFilter = tempFilter.filter(item => item.companyUID === this.companyFilter);
    }
    tempFilter = this.applyStatusFilter(tempFilter);

    this.displayList = tempFilter
      .filter(item => item['companyName'].toLowerCase().includes(this.searchText) ||
                      item.description.toLowerCase().includes(this.searchText) ||
                      item['sentUserName'].toLowerCase().includes(this.searchText) ||
                      (item.status > DocumentStatus.WAITING_APPROVAL && item['approvingUserName'].toLowerCase().includes(this.searchText)) ||
                      item['statusText'].toLowerCase().includes(this.searchText))
      .sort((e1, e2) => e1.description.localeCompare(e2.description));
  }

  applyStatusFilter(tempFilter): Document[] {
    if (this.statusFilter) {
      if (this.statusFilter === '3') {
        tempFilter = tempFilter.filter(item => item['isExpiring'] === true);
      } else if (this.statusFilter === '0') {
        tempFilter = tempFilter.filter(item => item['isExpired'] === true);
      } else if (this.statusFilter === '4') {
        tempFilter = tempFilter.filter(item => item.pending);
      } else {
        tempFilter = tempFilter.filter(item => item.status == this.statusFilter);
      }
    }

    return tempFilter;
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction == '') {
      return;
    }

    this.displayList = this.displayList.sort((a, b) => {
      const isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'description': return this.compare(a.description, b.description, isAsc);
        case 'company': return this.compare(a['companyName'], b['companyName'], isAsc);
        case 'history': return this.compare(a['sentUserName'], b['sentUserName'], isAsc);
        default: return 0;
      }
    });
  }

  private compare(a, b, isAsc) {
    return a.localeCompare(b) * (isAsc ? 1 : -1);
  }


  goToNew() {
    this.router.navigate(['documentos/novo']);
  }

  download(url: string) {
    window.location.href = url;
  }

  openApprovalModal(document: Document) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: document.description, action: 'Tem certeza que deseja aprovar o documento ' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmApproval(document.uid); }
    });
  }

  private confirmApproval(uid: string) {
    this.loading = true;
    this.dbService.update(`/documents/${uid}`, { status: DocumentStatus.APPROVED, approvingUserUID: this.user.uid } )
      .then(() => {
        Materialize.toast('Documento aprovado com sucesso', 2000);
        this.loadData();
      })
      .catch(error => console.log(error));
  }

  openDisapprovalModal(document: Document) {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '700px',
      data: { title: 'Desaprovar - ' + document.description, placeHolder: 'Motivo da reprovação', isCurrency: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDisapproval(document, result); }
    });
  }

  private confirmDisapproval(document: Document, reason: string) {
    const status = DocumentStatus.DISAPPROVED;

    this.loading = true;
    this.dbService.update(`/documents/${document.uid}`, { status: status, approvingUserUID: null, reason: reason } )
      .then(() => {
        Materialize.toast('Documento desaprovado com sucesso', 2000);
        this.loadData();
      })
      .catch(error => console.log(error));
  }

  openDeleteModal(document: Document) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: document.description }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(document.uid); }
    });
  }

  private confirmDelete(uid: string) {
    this.loading = true;
    this.dbService.remove('/documents', uid)
      .then(() => {
        Materialize.toast('Documento removido com sucesso', 2000);
        this.loadData();
      })
      .catch(error => console.log(error));
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/documents/documents.component.ts